"use client";

/**
 * Figma media icons. `currentColor` (not the Figma #161619 literal) so they
 * follow the theme's Text token like every other icon in the chrome.
 */

/** Upload arrow — the empty state of audio/document/etc. blocks. */
export function UploadIcon({ className }: { className?: string }) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden
            className={className}
        >
            <path
                d="M12 3V15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17 8L12 3L7 8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

/** Audio file — the "Replace audio" topbar button. */
export function AudioFileIcon({ className }: { className?: string }) {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden
            className={className}
        >
            <path
                d="M9.70837 18.3346H15C15.4421 18.3346 15.866 18.159 16.1786 17.8465C16.4911 17.5339 16.6667 17.11 16.6667 16.668V6.66797C16.6674 6.4039 16.6157 6.14231 16.5147 5.8983C16.4137 5.6543 16.2654 5.4327 16.0784 5.24631L13.0884 2.25631C12.902 2.06924 12.6804 1.92094 12.4364 1.81996C12.1924 1.71898 11.9308 1.66733 11.6667 1.66797H5.00004C4.55801 1.66797 4.13409 1.84357 3.82153 2.15613C3.50897 2.46869 3.33337 2.89261 3.33337 3.33464V11.9596"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6666 1.66797V5.83464C11.6666 6.05565 11.7544 6.26761 11.9107 6.42389C12.067 6.58017 12.2789 6.66797 12.5 6.66797H16.6666"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.66663 16.6654V10.832L9.16663 12.0604"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.00004 18.3333C5.92052 18.3333 6.66671 17.5871 6.66671 16.6667C6.66671 15.7462 5.92052 15 5.00004 15C4.07957 15 3.33337 15.7462 3.33337 16.6667C3.33337 17.5871 4.07957 18.3333 5.00004 18.3333Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

/** Document — the "Replace document" topbar button. */
export function DocumentFileIcon({ className }: { className?: string }) {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden
            className={className}
        >
            <path
                d="M5.00004 18.3346C4.55801 18.3346 4.13409 18.159 3.82153 17.8465C3.50897 17.5339 3.33337 17.11 3.33337 16.668V3.33464C3.33337 2.89261 3.50897 2.46869 3.82153 2.15613C4.13409 1.84357 4.55801 1.66797 5.00004 1.66797H11.6667C11.9305 1.66754 12.1918 1.71931 12.4355 1.82028C12.6792 1.92125 12.9005 2.06944 13.0867 2.2563L16.0767 5.2463C16.2641 5.43256 16.4127 5.65409 16.514 5.89811C16.6152 6.14212 16.6671 6.40378 16.6667 6.66797V16.668C16.6667 17.11 16.4911 17.5339 16.1786 17.8465C15.866 18.159 15.4421 18.3346 15 18.3346H5.00004Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6666 1.66797V5.83464C11.6666 6.05565 11.7544 6.26761 11.9107 6.42389C12.067 6.58017 12.2789 6.66797 12.5 6.66797H16.6666"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.33329 7.5H6.66663"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3333 10.832H6.66663"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3333 14.168H6.66663"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
